import React from 'react';
import {ThemeContext} from '../../common';

const EmptyPlayer = () => (
  <ThemeContext.Consumer>
    {theme => (
      <li className="team-player team-player_empty" style={{color: theme.primaryColor}}>+ Invite Player</li>
    )}
  </ThemeContext.Consumer>
);

export default EmptyPlayer;
